import Dialog from 'quasar/src/plugins/Dialog.js';

import useModel from '@/composables/useModel';
import useNotify from '@/composables/useNotify';

const { destroy } = useModel('alunos');
const { triggerPositive, triggerNegative } = useNotify();

async function handleDelete(id) {
    Dialog.create({
        title: 'Confirmação',
        message: 'Deseja realmente deletar este aluno?',
        cancel: true,
        persistent: true
    }).onOk(async () => {
        this.pending = true;
        const response = await destroy(id);
        if (response) {
            this.reloadCollection();
            triggerPositive('Exclusão concluída com sucesso!');
        } else {
            triggerNegative('Não foi possível concluir a exclusão.');
        }
        this.pending = false;
    });
}

export default handleDelete